/* @flow */
import React from 'react';
import { Collapse } from 'react-bootstrap';
import IconsRedesSociales from './IconsRedesSociales';
import FotosHelper from '../../helpers/FotosHelper';
import moment from 'moment';
import { stringify } from 'rebem-classname';

export default class Footer extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const block = "footer";
		return (
			<React.Fragment>
				<IconsRedesSociales block={block} socialIcons={this.props.socialIcons}/>

				<div className={stringify({block, elem:"lineaDivisora"})}></div>

					<div className={stringify({block, elem:"container"})}>
						<div className={stringify({block, elem:"list"})}>
							<div className={stringify({block, elem:"list-items"})}>
								<div className={stringify({block, elem:"list-titulo"})}>AlquilerArgentina</div>
								<div className={stringify({block, elem:"list-item"})}><a href="/">Inicio</a></div>
								<div className={stringify({block, elem:"list-item"})}><a href="/contacto.html">Contacto</a></div>
								<div className={stringify({block, elem:"list-item"})}><a href="/publicar.html">Publicá tu alojamiento</a></div>
								<div className={stringify({block, elem:"list-item"})}><a rel="nofollow" href="https://jobs.alquilerargentina.com/sobre-nosotros/">Sobre nosotros</a></div>
								<div className={stringify({block, elem:"list-item"})}><a rel="nofollow" href="https://jobs.alquilerargentina.com/">Trabajá con nosotros</a></div>
							</div>
						</div>
						<div className={stringify({block, elem:"list"})}>
							<div className={stringify({block, elem:"list-items"})}>
								<div className={stringify({block, elem:"list-titulo"})}>Secciones</div>
								<div className={stringify({block, elem:"list-item"})}><a href="/ofertas-imperdibles/">Ofertas imperdibles</a></div>
								<div className={stringify({block, elem:"list-item"})}><a href="/escapada/">Escapadas cercanas</a></div>
								<div className={stringify({block, elem:"list-item"})}><a href="https://www.alquilerargentina.com/blog/">Blog</a></div>
							</div>
						</div>
						<div className={stringify({block, elem:"list"})}>
							<div className={stringify({block, elem:"list-items"})}>
								<div className={stringify({block, elem:"list-titulo"})}>Redes Sociales</div>
								<a rel="nofollow" target='_blank' href="https://www.facebook.com/alquilerargentina">
									<div className={stringify({block, elem:"list-item-icon"})}>
										<div><span className="icon-facebook" /></div>
										<div className={stringify({block, elem:"list-text"})}>Facebook</div>
									</div>
								</a>
								<a rel="nofollow" target='_blank' href="https://twitter.com/AlqArgentina">
									<div className={stringify({block, elem:"list-item-icon"})}>
										<div><span className="icon-twitter" /></div>
										<div className={stringify({block, elem:"list-text"})}>Twitter</div>
									</div>
								</a>
								<a rel="nofollow" target='_blank' href="https://www.youtube.com/user/AlquilerArgentinaWeb">
									<div className={stringify({block, elem:"list-item-icon"})}>
										<div><span className="icon-youtube" /></div>
										<div className={stringify({block, elem:"list-text"})}>Youtube</div>
									</div>
								</a>
								<a rel="nofollow" target='_blank' href="https://www.instagram.com/alquilerargentina">
									<div className={stringify({block, elem:"list-item-icon"})}>
										<div><span className="icon-instagram" /></div>
										<div className={stringify({block, elem:"list-text"})}>Instagram</div>
									</div>
								</a>
							</div>
						</div>
						<div className={stringify({block, elem:"list"})}>
							<div className={stringify({block, elem:"list-items"})}>
								<div className={stringify({block, elem:"list-titulo"})}>Descargá la aplicación</div>
								<a rel="nofollow" target='_blank' href="https://play.google.com/store/apps/details?id=liricus.alquilerargentina">
									<div className={stringify({block, elem:"list-item-icon"})}>
										<img src={FotosHelper.imgV4("playstore.png?w=130")} alt="playstore" width="130"/>
									</div>
								</a>
								<a rel="nofollow" target='_blank' href="https://apps.apple.com/ve/app/alquiler-argentina/id1588111749">
									<div className={stringify({block, elem:"list-item-icon"})}>
										<img src={FotosHelper.imgV4("appstore.png?w=130")} alt="appstore" width="130"/>
									</div>
								</a>
							</div>
						</div>
					</div>

				<div className={stringify({block, elem:"visible"})}>

					<div style={{display:'flex', flexGrow: 1}}>
						<div style={{marginRight:15}}>
							© { moment().format('Y') } AlquilerArgentina
						</div>
						<div style={{ color:'#8c8c8c'}}>
							{process.env.MIX_VERSION ? process.env.MIX_VERSION.replace('prod-', '') : null}
						</div>
					</div>						
					<div className={stringify({block, elem:"condiciones"})}>
						<a rel="nofollow" href="/terminos-condiciones.html">Condiciones</a>
					</div>
				</div>
			</React.Fragment>
		);
	}  
}